<div>
  <fcom-modal
    [(open)]="isOpen"
    [buttons]="(status$ | async) === Status.IN_PROGRESS ? null : ModalButtons.CUSTOM"
    [title]="'MMB.view.eTicket.modal.title' | finLocalization"
    [ngSwitch]="status$ | async"
  >
    <div class="pr-large">
      <ng-container *ngSwitchCase="Status.INITIAL">
        <p class="pr-xsmall-b">{{ 'MMB.view.eTicket.modal.proceed' | finLocalization }}</p>
        <p class="pr-xsmall-b">{{ 'MMB.view.eTicket.modal.multipleTickets' | finLocalization }}</p>
        <p class="pr-xsmall-b">
          {{ 'MMB.view.eTicket.modal.deliverTo' | finLocalization }}:
          <strong>{{ (mainPaxInfo$ | async)?.email | lowercase }}</strong>
        </p>
        <p class="pr-xsmall-b">{{ 'MMB.view.eTicket.modal.correctEmail' | finLocalization }}</p>
      </ng-container>

      <ng-container *ngSwitchCase="Status.IN_PROGRESS">
        <div class="mr-xlarge-x align-center">
          <p class="align-center">{{ 'MMB.view.eTicket.modal.sending' | finLocalization }}</p>
          <fcom-loader [loaderType]="LoaderTheme.INLINE" class="pr-small-y block"></fcom-loader>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="Status.COMPLETE">
        <h3 class="font-heading-3 nordic-blue-900-text pr-small-b" data-testid="eticket-modal-success">
          {{ 'MMB.view.eTicket.modal.successTitle' | finLocalization }}
        </h3>
        <p>{{ 'MMB.view.eTicket.modal.successMessage' | finLocalization }}</p>
      </ng-container>

      <ng-container *ngSwitchCase="Status.ERROR">
        <h3 class="font-heading-3 nordic-blue-900-text pr-small-b" data-testid="eticket-modal-error">
          {{ 'MMB.view.eTicket.modal.errorTitle' | finLocalization }}
        </h3>
        <p>{{ 'MMB.view.eTicket.modal.error' | finLocalization }}</p>
      </ng-container>
    </div>

    <div buttons>
      <fcom-button
        *ngSwitchCase="Status.INITIAL"
        [text]="'actions.cancel' | finLocalization"
        (clickBtn)="isOpen = false"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        class="mr-xsmall-r"
      ></fcom-button>
      <fcom-button
        *ngSwitchCase="Status.INITIAL"
        [text]="'actions.continue' | finLocalization"
        (clickBtn)="orderTickets()"
        data-testid="eticket-modal-order-tickets-btn"
      ></fcom-button>
      <fcom-button
        *ngSwitchCase="Status.COMPLETE"
        [text]="'actions.done' | finLocalization"
        (clickBtn)="isOpen = false"
      ></fcom-button>
    </div>
  </fcom-modal>

  <div class="align-right mr-small-t">
    <fcom-button
      data-testid="mmb-pax-order-modal-button"
      (clickBtn)="openModal()"
      [text]="'MMB.view.eTicket.text' | finLocalization"
    ></fcom-button>
  </div>
</div>
